import React from 'react';
import { motion } from 'framer-motion';

const testimonials = [
  {
    name: "Sarah Chen",
    role: "Software Developer",
    text: "The most aesthetic pomodoro timer I've found online. Clean design and great features!",
    image: "https://i.pravatar.cc/150?img=1"
  },
  {
    name: "Michael Rodriguez",
    role: "Graduate Student",
    text: "This pomodoro timer online has transformed my study sessions. The statistics feature is incredibly motivating.",
    image: "https://i.pravatar.cc/150?img=2"
  },
  {
    name: "Emily Thompson",
    role: "Content Writer",
    text: "Whether on Mac or Windows, this pomodoro timer keeps me focused. Love the customizable settings!",
    image: "https://i.pravatar.cc/150?img=3"
  }
];

const TestimonialsSection: React.FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4 }}
      className="w-full max-w-4xl mx-auto px-4 sm:px-6 py-8"
    >
      <h2 className="text-2xl sm:text-3xl font-bold text-white text-center mb-8">
        What Our Users Say
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {testimonials.map((testimonial, index) => (
          <motion.div
            key={testimonial.name}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 * index }}
            className="bg-white/10 backdrop-blur-lg rounded-xl p-6 shadow-lg"
          >
            <div className="flex items-center mb-4">
              <img
                src={testimonial.image}
                alt={testimonial.name}
                className="w-12 h-12 rounded-full mr-4"
              />
              <div>
                <h3 className="font-semibold text-white">{testimonial.name}</h3>
                <p className="text-white/70 text-sm">{testimonial.role}</p>
              </div>
            </div>
            <p className="text-white/90 italic">{testimonial.text}</p>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default TestimonialsSection;
